import {useContext} from 'react';
import {useUiConfig} from '../../providers/UiConfigProvider';
import {useMediaQuery} from '../../providers/UiMediaQueryProvider';
import {ListBoxContext} from '../ListBox';
import {FauxTreeContext} from '../FauxTree';

/**
 * Used for feature flagging bottom sheets, can be removed once the rollout is finished.
 */
export type BottomSheetOverlayType = 'dialog' | 'drawer' | 'popover';

const useIsWithinListBoxContext = () => {
  const listBoxContext = useContext(ListBoxContext);
  // FauxTree is a modified version of ListBox used in SelectField and SearchField to support multi-selection
  // The component will be replaced once we have a proper Tree component
  const fauxTreeContext = useContext(FauxTreeContext);
  return (
    Object.keys(listBoxContext).length > 0 ||
    Object.keys(fauxTreeContext).length > 0
  );
};

function resolveBottomSheetsEnabled(
  enableBottomSheets:
    | boolean
    | {
        dialog?: boolean;
        drawer?: boolean;
        popover?: boolean;
      }
    | undefined,
  overlayType: BottomSheetOverlayType,
): boolean {
  if (enableBottomSheets === undefined || enableBottomSheets === false) {
    return false;
  }
  if (enableBottomSheets === true) {
    return true;
  }
  return enableBottomSheets[overlayType] === true;
}

export function useShouldDisplayBottomSheet(
  overlayType: BottomSheetOverlayType,
) {
  const {isSmallScreen, isTouch} = useMediaQuery();
  const uiConfig = useUiConfig();
  const enabledBottomSheets = resolveBottomSheetsEnabled(
    uiConfig?.enableBottomSheets,
    overlayType,
  );

  // Temporarily disable bottom sheets for SearchFields (and possible other components?), until we have a proper bottom sheet UX for them
  const isWithinListBoxContext = useIsWithinListBoxContext();

  return (
    (isSmallScreen ?? false) &&
    (isTouch ?? false) &&
    enabledBottomSheets &&
    !isWithinListBoxContext
  );
}
